function hulkapps_custom_init() {


function monitorCustomizationRequirement() {
    const targetElement = document.querySelector('.hulkapps_option_set');

    if (!targetElement) {
        console.error('Target element with class "custom-requirement" not found.');
        return;
    }

    const addToCartButton = document.getElementById('add-to-cart');
    if (!addToCartButton) {
        console.error('Add to Cart button not found.');
        return;
    }

    const observerCallback = () => {
        const customizationRequirementInput = document.querySelector('input[name="properties[Customisation Required?]"]');
        
        if (customizationRequirementInput) {
            const customizationRequirementValue = customizationRequirementInput.value;
            const requestQuoteButton = document.querySelector('.btn.hulk-quote');
            const customizationPosition = document.querySelector('input[name="properties[Customisation Position]"]');
              
            if (customizationRequirementValue == 'Yes') {
                addToCartButton.style.display = 'none';
                requestQuoteButton.style.display = 'block';
            } else {
                addToCartButton.style.display = '';
                requestQuoteButton.style.display = 'none';
            }
        }
    };

    const observer = new MutationObserver(observerCallback);

    const config = { childList: true, subtree: true, attributes: true };

    observer.observe(targetElement, config);

    observerCallback();
}
    
monitorCustomizationRequirement();

function logImageSrc() {
    const productImageElement = document.querySelector('.product__image');

    if (productImageElement) {
        const imageElement = productImageElement.querySelector('.image');
        if (imageElement) {
            const imgElement = imageElement.querySelector('img');
            const imgSrc = imgElement ? imgElement.src : null;

            if (imgSrc) {
                console.log('Updated Image src URL:', imgSrc);

                const hiddenInput = document.querySelector('.cart-helper[name="properties[Color Image]"]');
                if (hiddenInput) {
                    hiddenInput.value = imgSrc;
                } else {
                    console.log('Hidden input not found.');
                }
            } else {
                console.log('No img found or no src available.');
            }
        } else {
            console.log('No .image element found inside .product__image.');
        }
    } else {
        console.log('No .product__image element found.');
    }
}

logImageSrc();

const productImageElement = document.querySelector('.product__image');

if (productImageElement) {
    const observer = new MutationObserver(() => {
        logImageSrc(); 
    });
    
    observer.observe(productImageElement, {
        childList: true,
        attributes: true,
        subtree: true
    });

} else {
    console.log('No .product__image element found to observe.');
}

}

(function() {
    window.addEventListener('load', () => {
        console.log('LOADED');
        const hook = setInterval(() => {
            let hulkDiv = document.querySelector('div[id^="hulkapps_custom_options"]');
            if (hulkDiv) {
            clearInterval(hook);
            hulkapps_custom_init();
            }
        }, 500);
        setTimeout(() => {
            clearInterval(hook);
            
        }, 15000)
    });    
})();